import * as types from './types';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SINGLE_PROJECT:
      return state;
    case types.GET_SINGLE_PROJECT_SUCCESS:
      return action.payload?.wedding;
    case types.GET_SINGLE_PROJECT_FAIL:
      return state;
    default:
      return state;
  }
};
